var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 0C22.6046 0 23.5 0.895447 23.5 2V14C23.5 15.1046 22.6046 16 21.5 16H2.5C1.39543 16 0.5 15.1046 0.5 14V2C0.5 0.895447 1.39543 0 2.5 0H21.5ZM21 14C21.2761 14 21.5 13.7761 21.5 13.5V2.5C21.5 2.22388 21.2761 2 21 2H3C2.72386 2 2.5 2.22388 2.5 2.5V13.5C2.5 13.7761 2.72386 14 3 14H21Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.08 18.258L22.327 22.746L22.33 22.758C22.4053 23.0564 22.3381 23.3729 22.148 23.615C21.9578 23.8568 21.6676 23.9985 21.36 24H2.64101C2.33327 24.0001 2.04259 23.8586 1.85295 23.6162C1.66331 23.3738 1.59584 23.0576 1.67 22.759L2.923 18.246C3.03889 17.8065 3.43654 17.5005 3.89101 17.501H20.11C20.5687 17.501 20.9685 17.813 21.08 18.258ZM16 22.251C16.2761 22.251 16.5 22.0271 16.5 21.751C16.5 21.4749 16.2761 21.251 16 21.251H8C7.72386 21.251 7.5 21.4749 7.5 21.751C7.5 22.0271 7.72386 22.251 8 22.251H16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.4d03f5b2.svg";
export { ForwardRef as ReactComponent };